import GATSBY_COMPILED_MDX from "D:/React JS/Products/digipay-react-website/content/blog/difference-between-mobile-wallets-and-mobile-banking/index.mdx";
import React, {useEffect, useState} from "react";
import {Link, graphql} from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout/layout";
import {MDXProvider} from "@mdx-js/react";
import {Container, Col, Row, Image, Card} from 'react-bootstrap';
import {GatsbyImage, getSrc, getImage} from "gatsby-plugin-image";
import {AuthorDefault} from "../utils/imageConst";
import {AnchorLink} from "gatsby-plugin-anchor-links";
import Scrollspy from "react-scrollspy";
import SocialShare from "../components/social-share";
import LazyLoad from "react-lazy-load";
import IcCtaMail from '../images/ic-cta-mail.svg';
export const Head = ({data}) => {
  const post = data.mdx.frontmatter;
  const socialImg = getSrc(post?.socialImage);
  let schemaObj = {};
  try {
    schemaObj = JSON.parse(post.schema);
  } catch (error) {
    console.error('Error parsing schema JSON:', error);
  }
  return React.createElement(React.Fragment, null, React.createElement(Seo, {
    title: post.metaTitle || post.title,
    description: post.metaDescription,
    ogImage: socialImg,
    twitterImage: socialImg
  }), post.schema ? React.createElement("script", {
    type: "application/ld+json",
    "data-gatsby-head": "true"
  }, JSON.stringify(schemaObj)) : null);
};
const BlogMdxSingle = ({data: {site, allMdx, mdx: post}, children}) => {
  const socialUrl = typeof window !== 'undefined' ? window.location.href : '';
  const posts = allMdx?.nodes;
  const curCat = post.frontmatter?.categories;
  const curTitle = post.frontmatter?.title;
  const author = post.frontmatter?.author;
  const siteinfo = site?.siteMetadata;
  const url = post.tableOfContents?.items?.map(tag => tag?.url?.substring(1));
  const imageAuth = getImage(author?.img);
  const anchorLinkBlank = {
    a: props => React.createElement("a", Object.assign({}, props, {
      target: "_blank",
      "aria-label": "anchor link"
    }))
  };
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 300);
    });
  }, []);
  const getPostUrl = post => {
    const isNewsRoom = post.frontmatter.categories?.includes("Newsroom");
    const slug = post?.fields?.slug || '';
    if (isNewsRoom) {
      return `/press-release${slug.replace("/blog", "")}`;
    } else {
      return slug;
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(Layout, null, React.createElement("section", {
    className: "section banner-background d-md-flex align-items-center pb-0"
  }, React.createElement(Container, {
    className: "pt-5 mt-lg-5 container"
  }, React.createElement("div", {
    className: "banner-content blog-post-heading text-center mt-lg-4 mb-5 pb-md-5"
  }, React.createElement("div", {
    className: "category-single-post font-size-14 mb-3"
  }, curCat?.map((category, index) => React.createElement(Link, {
    key: index,
    to: `/blog/category/${category}`.toLowerCase().replace(/ /g, "-"),
    rel: "category tag",
    className: "category"
  }, category, " ", React.createElement("span", {
    className: "coma-sep"
  }, ", ")))), React.createElement("h1", {
    className: "title mb-0 font-size-40"
  }, post?.frontmatter?.title), React.createElement("div", {
    className: `py-3 blog-single-title text-start ${scroll ? "blog-title-fixed" : ""}`
  }, React.createElement(Container, null, React.createElement("p", {
    className: "mb-0 h4 title text-start"
  }, post?.frontmatter?.title)))), React.createElement("div", {
    className: "single-line-meta font-size-16 d-flex align-items-center justify-content-space-between flex-wrap py-4 border-top"
  }, React.createElement("div", {
    className: "d-flex align-items-center me-auto"
  }, React.createElement("i", {
    className: "zmdi zmdi-refresh me-2"
  }), "Updated on ", post.frontmatter?.modifyDate ? post.frontmatter?.modifyDate : post.frontmatter?.date), React.createElement("div", {
    className: "d-flex align-items-center"
  }, React.createElement("i", {
    className: "zmdi zmdi-time me-2"
  }), post?.fields?.timeToRead?.text)))), React.createElement("section", {
    className: "blog-post-section section"
  }, React.createElement(Container, {
    className: "pb-5"
  }, React.createElement("div", {
    className: "blog-post-container"
  }, React.createElement("div", {
    className: "social-share"
  }, React.createElement("p", {
    className: "font-size-14"
  }, "SHARE"), React.createElement(SocialShare, {
    url: socialUrl,
    title: post?.frontmatter.title,
    description: post?.frontmatter.excerpt
  })), React.createElement(Row, {
    className: "g-5"
  }, React.createElement(Col, {
    lg: 8
  }, React.createElement("div", {
    className: "blog-post-content"
  }, React.createElement(MDXProvider, {
    components: anchorLinkBlank
  }, children)), React.createElement("div", {
    className: "author d-block d-md-flex align-items-start"
  }, React.createElement("div", {
    className: "author-image pe-4 mb-4 mb-md-0"
  }, author?.img ? React.createElement(GatsbyImage, {
    loading: "lazy",
    className: "bio-avatar",
    image: imageAuth,
    width: 100,
    height: 96,
    alt: "author-profile"
  }) : React.createElement(Image, {
    loading: "lazy",
    className: "bio-avatar lazyload",
    src: AuthorDefault,
    width: 100,
    height: 96,
    alt: "author-profile"
  })), React.createElement("div", {
    className: "author-content"
  }, React.createElement("h3", {
    className: "author-name h5"
  }, React.createElement(Link, {
    to: `/blog/author/${author?.name ? author?.name : siteinfo?.author}`.toLowerCase().replace(/ /g, "-"),
    className: "authLink"
  }, author?.name ? author?.name : siteinfo?.author)), React.createElement("p", {
    className: "author-info"
  }, author?.description ? author?.description : siteinfo?.authorDescription)))), React.createElement(Col, {
    lg: 4,
    className: "ps-lg-5 blog-sidebar"
  }, React.createElement("div", {
    className: "table-of-contents sticky-section"
  }, React.createElement("div", {
    className: "mb-5"
  }, url ? React.createElement("h4", {
    className: "mb-4 text-muted"
  }, "Table of contents") : null, React.createElement(Scrollspy, {
    offset: -175,
    className: "list-unstyled toc",
    items: url,
    currentClassName: "active"
  }, post.tableOfContents?.items?.map(heading => {
    if (heading?.title !== '') {
      return React.createElement("li", {
        key: heading.url
      }, React.createElement(AnchorLink, {
        to: `${post?.frontmatter?.slug}/${heading.url}`,
        stripHash: true
      }, heading.title));
    }
    return null;
  }))), React.createElement(Card, {
    className: "blog-cta bg-dark"
  }, React.createElement(Card.Body, null, React.createElement(LazyLoad, {
    offset: 150
  }, React.createElement(Image, {
    className: "cta-icon lazyload",
    width: 139,
    height: 208,
    src: IcCtaMail,
    alt: "CTA icon"
  })), React.createElement("h4", {
    className: "text-white fw-medium"
  }, "Transform your business with DigiPay.Guru’s secure & scalable solutions"), React.createElement("a", {
    href: "/contact-us",
    className: "btn btn-primary-theme mt-4 min-w-150",
    "aria-label": "Book a demo",
    rel: "noreferrer",
    target: "_blank"
  }, React.createElement("span", null, "Book a demo")))))))))), React.createElement("section", {
    className: "blog-list-section section related-post bg-light"
  }, React.createElement(Container, {
    className: "py-5"
  }, React.createElement("div", {
    className: "w-75"
  }, React.createElement("div", {
    className: "section-title mb-5 pb-1"
  }, React.createElement("h2", {
    className: "heading fw-semibold mb-0"
  }, "Related Post"))), React.createElement(Row, {
    xs: 1,
    lg: 3,
    className: "g-4"
  }, posts.filter(node => node?.frontmatter?.categories?.some(i => curCat?.includes(i)) && node?.frontmatter?.title !== curTitle).map((post, index) => {
    const imageReltd = getImage(post?.frontmatter?.featured);
    if (index < 3) {
      return React.createElement(Col, {
        key: index
      }, React.createElement(Link, {
        to: getPostUrl(post),
        className: "blog-list-card single"
      }, React.createElement("div", {
        className: "blog-image"
      }, React.createElement(GatsbyImage, {
        loading: "lazy",
        width: 416,
        height: 250,
        image: imageReltd,
        alt: "featured"
      })), React.createElement("div", {
        className: "blog-list-content mt-4"
      }, React.createElement("h2", {
        className: "blog-title fw-normal h4"
      }, post?.frontmatter?.title))));
    } else {
      return null;
    }
  }))))));
};
BlogMdxSingle
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogMdxSingle, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const BlogMdx = graphql`
query ($id:  String!) {
  site {
    siteMetadata {
        author
        authorDescription
        social {
          twitter
        }
    }
  }
  mdx(id: { eq: $id }) {
    tableOfContents
    body
    fields {
      timeToRead {
        text
      }
    }
    frontmatter {
      date(formatString: "MMMM DD, YYYY")
      modifyDate(formatString: "MMMM DD, YYYY")
      title
      slug
      categories
      metaTitle
      metaDescription
      schema
      author {
        name
        description
        img {
          childImageSharp {
            gatsbyImageData(width: 100)
          }
        }
      }
      socialImage {
        childImageSharp {
          gatsbyImageData
        }
      }
      featured {
        childImageSharp {
          gatsbyImageData(width: 720)
        }
      }
    }
  }
  allMdx(sort: { frontmatter: { modifyDate: DESC } }) {
      nodes {
        id
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          modifyDate(formatString: "MMMM DD, YYYY")
          title
          categories
          featured {
            childImageSharp {
              gatsbyImageData(width: 416)
            }
          }  
        }
      }
    }
}`;
